import { getContext } from './audio-context';
import MediaElementAudioPlayer from './MediaElementAudioPlayer';
import { DrawableAudio } from './types';

// an audio player driven by an HTMLMediaElement attached to the WebAudio graph.
// Waveform data can be sampled from the WebAudio Analyser node by calling `waveformData()`
export default class WebAudioPlayer
  extends MediaElementAudioPlayer
  implements DrawableAudio
{
  private context: AudioContext;

  private source: MediaElementAudioSourceNode;

  private gain: GainNode;

  private analyser: AnalyserNode;

  private frequencySample: Uint8Array;

  constructor(element: HTMLMediaElement, ctx: AudioContext = getContext()) {
    super(element);

    this.context = ctx;

    this.source = this.context.createMediaElementSource(this.element);

    this.gain = this.context.createGain();

    this.analyser = this.context.createAnalyser();
    this.analyser.smoothingTimeConstant = 0.45;
    this.frequencySample = new Uint8Array(this.analyser.frequencyBinCount);

    // connect graph
    //  - gain should not be connected to the analyser, otherwise volume will
    //    affect the min/max height of the waveform
    //  - analyser does not need to be connected to a destination in order to work
    this.source.connect(this.gain);
    this.source.connect(this.analyser);
    this.gain.connect(this.context.destination);
  }

  public get waveformData() {
    if (!this.paused) {
      this.analyser.getByteFrequencyData(this.frequencySample);
    }
    return this.frequencySample;
  }

  public get waveformDataSize() {
    return this.frequencySample.length;
  }

  public set volume(value: number) {
    this.gain.gain.value = value;
  }
}
